import { makeStyles } from '@material-ui/core/styles';
import { useFormContext } from 'react-hook-form';
import { Grid } from '@material-ui/core';
import ContentBox from 'components/CncUI/ContentBox';
import Typography from 'components/CncUI/Typography';
import Notification from 'components/Notifications/Notification';
import { isValid, format } from 'date-fns';
import formatNotification from './formatNotification';

const useStyles = makeStyles(({ spacing }) => ({
  contentBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: { marginBottom: spacing(6) },
  notification: { marginBottom: spacing(2) },
  conditions: { marginBottom: spacing(6) },
}));

const NotificationPreview = ({ notificationForm, user, groups }) => {
  const classes = useStyles();
  const { watch } = useFormContext();
  const notification = formatNotification(notificationForm);

  const referenceType = watch('referenceType');
  const groupSelectValue = watch('groupSelect');
  const selectedGroup =
    (groups || []).find(g => g.id === groupSelectValue?.id) || {};

  return (
    <ContentBox className={classes.contentBox}>
      <Grid item xs={12}>
        <Typography variant="h3" className={classes.title}>
          Preview
        </Typography>
      </Grid>
      <Grid item xs={11} md={7} lg={6} className={classes.notification}>
        <Notification notification={notification} />
      </Grid>
      <Grid item xs={12}>
        <Typography
          align="center"
          className={classes.conditions}
          id="Notification-preview-sendTiming"
        >
          Will be sent{' '}
          <b>
            {notificationForm.startAt === 'now'
              ? 'immediately'
              : !isValid(notification.startAt)
              ? '(ADD VALID DATE)'
              : `on ${format(notification.startAt, 'MMM do, yyyy')} at ${format(
                  notification.startAt,
                  'hh:mm aa',
                )}`}
          </b>
          <br />
          to{' '}
          {referenceType === 'loginId' && (
            <b>
              {user && user.loginId
                ? `${user.firstName} ${user.lastName}`
                : 'NO USER SELECTED'}
            </b>
          )}
          {referenceType === 'groupId' && (
            <b>
              {groupSelectValue && selectedGroup.id
                ? selectedGroup.name
                : 'NO OKTA GROUP SELECTED'}
            </b>
          )}
          <br />
          Expires {notificationForm.expireAt === '7d' ? 'in ' : 'on '}
          <b>
            {notificationForm.expireAt === '7d'
              ? '7 days'
              : !isValid(notification.expireAt)
              ? '(ADD VALID DATE)'
              : `${format(notification.expireAt, 'MMM do, yyyy')} at ${format(
                  notification.expireAt,
                  'hh:mm aa',
                )}`}
          </b>
          {notificationForm.expireAt === '7d' ? ' after being sent' : ''}.
        </Typography>
      </Grid>
    </ContentBox>
  );
};

export default NotificationPreview;
